import { ROUTE_COMPANY } from '@/constants/routes';
import routesGenerator from '@/router/routesGenerator';
import md5 from 'md5';
import { pathToAction } from 'redux-first-router';
import { useCompanyCanonicalUrl } from './useCompany';

export function isCompanySplit(canonicalUrl: string) {
  //We won't split company report for native
  if (RUNTIME_ENV === 'native') return false;
  if (!canonicalUrl) return false;

  const action = pathToAction(canonicalUrl, routesGenerator());
  if (action.type !== ROUTE_COMPANY) return false;

  const hash: string = md5(canonicalUrl);
  //This value is a hexadecimal: 0,1,2,3,4,5,6,7, 8,9,a,b,c,d,e,f
  const least = hash.slice(hash.length - 1);

  //50/50 split:
  const variant = Number(least) < 8 ? 'control' : 'split';
  return variant === 'split';
}

export function useCompanySplitDetect(): boolean {
  const canonicalUrl = useCompanyCanonicalUrl();

  return isCompanySplit(canonicalUrl);
}
